import { paramCase } from "param-case";
import latinize from "latinize";
import moment from "moment";
import Vue from "vue";

export default {
  setDatePickerState(state, status) {
    state.singularDatePicker = status;
  },
  toggleRightDrawer: function (state) {
    state.rightDrawer = !state.rightDrawer;
  },
  closeRightDrawer: function (state) {
    state.rightDrawer = false;
  },
  appendHierarchyLevelElements: function (state, { list }) {
    state.hierarchyLevelElements = state.hierarchyLevelElements.concat(list);
  },
  setReferenceDate: function (state, newDate) {
    state.selectedFilters.referenceDate = newDate;
  },
  initCustomFilters: function (state, newFilters) {
    Vue.set(state, "getCustomFilters", newFilters);
  },
  setValueOfCustomFilter: function (state, { key, value }) {
    Vue.set(state.getCustomFilters, key, value);
  },
  setHierarchyLevel: function (state, { hierarchy, key, value }) {
    Vue.set(state.selectedFilters[hierarchy].hierarchy, key, value);
  },
  addHierarchyLevel: function (state, { hierarchy, key, value }) {
    state.selectedFilters[hierarchy].hierarchy[key].push(value);
  },
  removeHierarchyLevel: function (state, { hierarchy, key, value }) {
    let index = state.selectedFilters[hierarchy].hierarchy[key].indexOf(value);
    state.selectedFilters[hierarchy].hierarchy[key].splice(index, 1);
  },
  initHierarchy: function (state, { hierarchy, levelList }) {
    // for (let i = 0; i < length; i++) {
    //     state.selectedFilters[hierarchy].hierarchy.push(null)
    // }
    levelList.forEach((level) => {
      Vue.set(
        state.selectedFilters[hierarchy].hierarchy,
        paramCase(latinize(level.name)),
        []
      );
    });
  },
  setDateRange: function (state, { from, to }) {
    Vue.set(state.selectedFilters, "startDate", moment(from, "YYYY/MM/DD"));
    Vue.set(state.selectedFilters, "endDate", moment(to, "YYYY/MM/DD"));
  },
  setSingleDate: function (state, date) {
    Vue.set(state.selectedFilters, "singleDate", moment(date, "YYYY/MM/DD"));
  },
  addProductToProductList: function (state, { index, value }) {
    Vue.set(state.selectedFilters.product.productList, index, value);
  },
  removeProductFromProductList: function (state, { index }) {
    state.selectedFilters.product.productList.splice(index, 1);
  },
  addStoreToStoreList: function (state, { index, value }) {
    Vue.set(state.selectedFilters.store.storeList, index, value);
  },
  removeStoreFromStoreList: function (state, { index }) {
    state.selectedFilters.store.storeList.splice(index, 1);
  },
  addNielsenToNielsenList: function (state, { index }) {
    state.selectedFilters.geography.nielsenList.splice(index, 1);
  },
  removeNielsenFromNielsenList: function (state, { index }) {
    state.selectedFilters.geography.nielsenList.splice(index, 1);
  },
  clearListByHierarchy: function (state, { hierarchy }) {
    state.selectedFilters[hierarchy][`${hierarchy}List`].splice(0);
  },
  clearFilters: function (state) {
    while (state.selectedFilters.store.storeList.length) {
      state.selectedFilters.store.storeList.pop();
    }

    while (state.selectedFilters.product.productList.length) {
      state.selectedFilters.product.productList.pop();
    }

    while (state.selectedFilters.geography.nielsenList.length) {
      state.selectedFilters.geography.nielsenList.pop();
    }

    for (var keystore in state.selectedFilters.store.hierarchy) {
      while (
        Object.keys(state.selectedFilters.store.hierarchy[keystore]).length
      ) {
        state.selectedFilters.store.hierarchy[keystore].pop();
      }
    }

    for (var keyproduct in state.selectedFilters.product.hierarchy) {
      while (
        Object.keys(state.selectedFilters.product.hierarchy[keyproduct]).length
      ) {
        state.selectedFilters.product.hierarchy[keyproduct].pop();
      }
    }
    for (var keygeography in state.selectedFilters.geography.hierarchy) {
      while (
        Object.keys(state.selectedFilters.geography.hierarchy[keygeography])
          .length
      ) {
        state.selectedFilters.geography.hierarchy[keygeography].pop();
      }
    }

    state.selectedFilters.startDate = moment();
    state.selectedFilters.endDate = moment();
    state.selectedFilters.singleDate = moment();
    state.customFilters = null;

    // state.selectedFilters = {
    //   startDate: moment(),
    //   endDate: moment(),
    //   singleDate: moment(),
    //   product: {
    //     hierarchy: {},
    //     productList: [],
    //     internalCode: null,
    //     productDescription: null,
    //   },
    //   store: {
    //     hierarchy: {},
    //     storeList: [],
    //   },
    //   geography: {
    //     hierarchy: {},
    //     nielsenList: [],
    //   },
    //   sellers: {
    //     salesDirector: null,
    //     NAM: null,
    //     KAM: null,
    //     supervisor: null,
    //     seller: null,
    //     promoter: null,
    //     repositor: null,
    //   },
    // };
  },
  setDaysWithoutSales: function (state, value) {
    state.customFilters.dwsa_aggreg = value;
  },
  setCoverageDaysView: function (state, value) {
    state.customFilters.coverage_days = value;
  },
  setAbcSelected: function (state, value) {
    state.customFilters.abcSelected = value;
  },
  setCardexStatus: function (state, value) {
    state.customFilters.cardexStatus = value;
  },
  addEmployeeToEmployeeList: function (state, { index, value }) {
    Vue.set(state.selectedFilters.employee.employeeList, index, value);
  },
  removeEmployeeToEmployeeList: function (state, { index }) {
    state.selectedFilters.employee.employeeList.splice(index, 1);
  },
};
